/* Midnight countdown to next local midnight (resets daily)
   Targets any element with: [data-midnight-countdown]
*/
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function nextLocalMidnight(now) {
    const t = new Date(now);
    t.setHours(24, 0, 0, 0); // next midnight, visitor local time
    return t;
  }

  function mount(el) {
    const hh = el.querySelector('[data-hh]');
    const mm = el.querySelector('[data-mm]');
    const ss = el.querySelector('[data-ss]');
    if (!hh || !mm || !ss) return;

    function tick() {
      const now = new Date();
      const target = nextLocalMidnight(now);
      let diff = target - now;
      if (diff < 0) diff = 0;

      const total = Math.floor(diff / 1000);
      const hours = Math.floor(total / 3600);
      const minutes = Math.floor((total % 3600) / 60);
      const seconds = total % 60;

      hh.textContent = pad(hours);
      mm.textContent = pad(minutes);
      ss.textContent = pad(seconds);
    }

    tick();

    // align to real seconds to avoid drift
    const align = 1000 - (Date.now() % 1000);
    setTimeout(function () {
      tick();
      setInterval(tick, 1000);
    }, align);
  }

  document.querySelectorAll('[data-midnight-countdown]').forEach(mount);
})();
